import { Injectable, inject } from '@angular/core';
import {
  StorageV2Service,
  StoreV2,
  UserPreferencesService,
  MachineService,
} from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ViewState {
  selectedPlant: string;
}

const selectedPlantKey = 'AssetManager:selectedPlant';

@Injectable()
export class SelectedPlantService extends StoreV2<ViewState> {
  private readonly machinService = inject(MachineService);
  private readonly userPreferenceService = inject(UserPreferencesService);

  view$: Observable<ViewState> = this.state$.pipe(map((selectedView) => selectedView));

  constructor() {
    const storageService = inject(StorageV2Service);

    super(
      {
        selectedPlant: '',
      },
      'AssetViewService',
      {
        storageService,
        name: 'AssetViewService',
      }
    );
    this.userPreferenceService.get(selectedPlantKey).subscribe((selectedPlant) =>
      this.setState('got assets view settings', {
        selectedPlant: selectedPlant === undefined ? '' : selectedPlant,
      })
    );
  }

  /**
   * Go to plant view and center plant of given machine.
   */
  goToPlantOfMachine(machineId: string) {
    this.setState('going to plant of given machine', {
      selectedPlant: this.machinService.state[machineId].plantId,
    });
  }

  /**
   *
   * Update the selected plant, center it on map and save it in backend.
   */
  updateSelectedPlant(plantId: string) {
    const _plantId = plantId === this.state.selectedPlant ? '' : plantId;
    this.userPreferenceService.set(selectedPlantKey, _plantId);
    this.setState('going to plant', {
      selectedPlant: _plantId,
    });
  }
}
